import UserNotification from "util/UserNotification";
import { createNotFoundError } from "logic/errors/ReportedErrors";
import ErrorsActions from "actions/errors/ErrorsActions";
const _displaySuccessNotification = (successNotification, ...args) => {
  const { message, title } = successNotification(...args);
  UserNotification.success(message, title || "Success");
};
const _displayErrorNotification = (errorNotification, error, ...args) => {
  var _a, _b;
  let errorMessage = String(error);
  if (((error == null ? void 0 : error.status) === 400 || (error == null ? void 0 : error.status) === 500) && ((_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.message)) {
    errorMessage = `${error.additional.body.message} - ${error.message}`;
  }
  const { message, title } = errorNotification(errorMessage, ...args);
  UserNotification.error(message, title || "Error");
};
const notifyingAction = ({
  action,
  success: successNotification,
  error: errorNotification,
  notFoundRedirect
}) => (...args) => action(...args).then((result) => {
  if (successNotification) _displaySuccessNotification(successNotification, ...args);
  return result;
}).catch((error) => {
  if (notFoundRedirect && (error == null ? void 0 : error.status) === 404) {
    ErrorsActions.report(createNotFoundError(error));
    throw error;
  }
  _displayErrorNotification(errorNotification, error, ...args);
  throw error;
});
export default notifyingAction;
